export default "__VITE_PUBLIC_ASSET__1b6d802c__"